import React, { useState, useCallback } from 'react';

import Dropdown, { VirtualizedMenu } from '@adsk/alloy-react-dropdown';
import Portal from '@adsk/alloy-react-portal';

import { getFilteredItems, renderDropdownMenuItem } from '../helpers/utils';

const SelectBox = ({
  items,
  selectedItem,
  placeholder: placeholderProp,
  setSelectedItem,
  renderFooter: renderFooterProp,
}) => {
  const shouldCustomizeMenuFooter = renderFooterProp || !selectedItem;

  const [inputValue, setInputValue] = useState('');
  const [placeholder, setPlaceholder] = useState(placeholderProp);

  const onInputValueChange = useCallback(
    ({ inputValue }) => setInputValue(inputValue),
    [],
  );

  const onIsOpenChange = useCallback(
    ({ isOpen, selectedItem }) => {
      setPlaceholder(isOpen ? null : placeholderProp);
      if (!isOpen && !selectedItem) {
        setInputValue('');
      }
    },
    [placeholderProp],
  );

  const onSelectedItemChange = useCallback(
    ({ selectedItem }) => {
      setSelectedItem(selectedItem);
    },
    [setSelectedItem],
  );

  const renderMenuItem = (itemProps) =>
    renderDropdownMenuItem(itemProps, inputValue);

  const renderFooter = () => (renderFooterProp ? renderFooterProp() : null);

  return (
    <Dropdown
      isAutocomplete
      style={{ width: '100%' }}
      placeholder={placeholder}
      inputValue={inputValue}
      items={items}
      selectedItem={selectedItem}
      getFilteredItems={getFilteredItems}
      renderMenu={(menuProps, virtualProps) => (
        <Portal container={document.body}>
          {VirtualizedMenu.render(
            {
              ...menuProps,
              renderMenuItem,
              ...(shouldCustomizeMenuFooter && { renderFooter }),
            },
            virtualProps,
          )}
        </Portal>
      )}
      onInputValueChange={onInputValueChange}
      onIsOpenChange={onIsOpenChange}
      onSelectedItemChange={onSelectedItemChange}
    />
  );
};

export default SelectBox;
